import React from 'react';

interface Props {
  heading: string;
  subheading: string;
  desc?: string;
}

const Discord = ({ heading, subheading, desc }: Props) => {
  return (
    <div className="mx-auto mt-16 max-w-7xl py-10">
      <div className="mx-auto max-w-[800px] px-6 pb-12 lg:px-8 ">
        <h4 className="pb-2 text-center text-[28px] font-semibold text-white">{heading}</h4>
        <div className="mx-auto max-w-3xl pb-2 text-center text-2xl font-bold text-white">
          {subheading}
        </div>
        <div className="border-gradient m-auto mt-2 h-0.5 w-16 bg-gradient-to-r from-blue-500 to-teal-500"></div>
        <p className="py-5 text-center">{desc}</p>
        <div className="text-center">
          <a
            href="https://discord.gg/6A3M7gXVPw"
            target="_blank"
            className="h-13 inline-flex w-64 flex-none items-center justify-center rounded-md bg-[#7186cd] p-3 text-base font-semibold leading-6 text-white no-underline hover:bg-white hover:text-[#7186cd]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              className="mr-4"
            >
              <path
                fill="currentColor"
                d="M8.52 13.846c-1.04 0-1.888-.945-1.888-2.102c0-1.156.827-2.1 1.889-2.1c1.05 0 1.91.944 1.889 2.1c0 1.157-.839 2.102-1.89 2.102Zm6.974 0c-1.04 0-1.89-.945-1.89-2.102c0-1.156.829-2.1 1.89-2.1c1.05 0 1.91.944 1.89 2.1c0 1.157-.829 2.102-1.89 2.102Zm-5.369-9.523l-.308-.563l-.634.105a16.353 16.353 0 0 0-4.158 1.28l-.228.106l-.142.209c-2.613 3.854-3.33 7.648-2.975 11.376l.039.406l.33.24a16.909 16.909 0 0 0 5.078 2.543l.79.242L9.03 17.55c1.91.472 4.03.473 5.939 0l1.107 2.718l.79-.243a16.822 16.822 0 0 0 5.08-2.544l.327-.238l.04-.402c.436-4.32-.697-8.084-2.958-11.385l-.142-.207l-.228-.104a16.575 16.575 0 0 0-4.154-1.280l-.618-.103l-.314.541a8.622 8.622 0 0 0-.263.494a15.878 15.878 0 0 0-3.263 0a14.12 14.12 0 0 0-.248-.474ZM6.715 16.61c.197.114.405.226.61.328l-.449 1.096a15.022 15.022 0 0 1-3.428-1.778c-.225-3.139.413-6.305 2.564-9.57a14.551 14.551 0 0 1 2.824-.913c.06.125.116.247.162.356l.273.643l.692-.101a14.107 14.107 0 0 1 4.09 0l.69.1l.272-.642c.047-.112.102-.234.16-.356c.977.21 1.923.519 2.828.915c1.875 2.82 2.821 5.966 2.546 9.567a14.905 14.905 0 0 1-3.43 1.778l-.445-1.094c.206-.103.414-.215.613-.329c.49-.282 1.017-.634 1.353-.97l-1.28-1.28c-.163.164-.523.42-.977.682c-.444.256-.885.463-1.167.556c-2.003.663-4.428.663-6.432 0c-.281-.093-.722-.3-1.166-.556c-.454-.261-.814-.518-.978-.682l-1.28 1.28c.337.336.864.688 1.354.97Z"
              />
            </svg>
            Join Our Free Discord
          </a>
        </div>
      </div>
    </div>
  );
};

export default Discord;
